<div class="alert-success">
  <div>
    <img src="https://static.twonas.com/apps/ticks/tick-default.svg" />
  </div>
</div>
